import DiscountApplicationRulesBxgyAutoAddedBuyX from './DiscountApplicationRulesBxgyAutoAddedBuyX'
import DiscountApplicationRulesBxgyGetY from './DiscountApplicationRulesBxgyGetY'
import MaxUsesPerOrder from '../../../MaxUsesPerOrder'
import { useDiscountForm } from '../../../hooks/useDiscountForm'
import { StandardPrerequisite, UiConfigDiscountType } from 'src/lib/types/discountsV2'

const DiscountApplicationRulesBxgyAutoAdded = () => {
  return (
    <div className='flex flex-col w-full'>
      <DiscountApplicationRulesBxgyAutoAddedBuyX />
      <DiscountApplicationRulesBxgyGetY type={UiConfigDiscountType.BXGY_AUTO_ADDED} />

      <MaxUsesPerOrder />
    </div>
  )
}

export default DiscountApplicationRulesBxgyAutoAdded
